import { Flex } from '@change-corgi/design-system-legacy/layout';

import { BaseQuestionField } from './components/BaseQuestionField';
import { useQuestionField } from './hooks/useQuestionField';

export const QuestionField: React.FC = () => {
	const {
		data: { parent, questions },
	} = useQuestionField();

	if (!parent || !questions.length) return null;

	return (
		<Flex mb={8} sx={{ flexDirection: 'column', gap: 8 }}>
			{questions.map((question, idx) => (
				<BaseQuestionField key={question.name} parent={parent} question={question} idx={idx + 1} />
			))}
		</Flex>
	);
};
